import { useCallback, useState } from "react";
import { clearPromptRetryIdentitiesForComposer } from "@/lib/prompt-receipt-bus";
import { clearPromptRetryEnvelopesForComposer } from "@/lib/prompt-retry-envelope";

export function useConversationFrameDraft(composerId: string) {
  const [draft, setDraft] = useState("");
  const onChange = useCallback(
    (value: string) => {
      setDraft((current) => {
        if (current !== value) {
          clearPromptRetryIdentitiesForComposer(composerId);
          clearPromptRetryEnvelopesForComposer(composerId);
        }
        return value;
      });
    },
    [composerId],
  );
  return { draft, onChange };
}
